<template>
  <section id="footer_main">
    <div>
      <div class="footer_area">
        <img :src="this.getImage('top/mori.png')" class="footer_img"/>
        <div class="footer_block">
          <div class="footer_line"></div>
          <div class="footer_item">
            <div>
              <img :src="this.getImage('common/icon_factory.svg')" class="icon"/>
            </div>
            <div>
              <div class="footer_text">国内製造・工場直送</div>
              <div class="footer_subtext">ご注文確定から岐阜県郡上八幡にある工場にて製造を開始します。工場から直送させていただきます。</div>
            </div>
          </div>
          <div class="footer_line"></div>
          <div class="footer_item">
            <div>
              <img :src="this.getImage('common/icon_warranty.svg')" class="icon"/>
            </div>
            <div>
              <div class="footer_text">安心の1年保証</div>
              <div class="footer_subtext">配達中の商品破損や、取扱説明書に従った使用状態で保証期間内に故障した場合は、無償修理の対応をさせていただきます。</div>
            </div>
          </div>
          <div class="footer_line"></div>
          <div class="footer_item">
            <div>
              <img :src="this.getImage('common/icon_cash.svg')" class="icon"/>
            </div>
            <div>
              <div class="footer_text">追加料金一切なし</div>
              <div class="footer_subtext">商品をカスタマイズすると、すぐにお見積もり価格が表示されます。その価格から追加で費用がかかることはございません。</div>
              </div>
          </div>
          <div class="footer_line"></div>
        </div>
      </div>
      <div>
        <a href="#" id="page_top"></a>
      </div>
    </div>
    <div class="footer_category_area">
      <div class="space"></div>
      <div class="footer_logo">
        <img :src="this.getImage('common/logo.png')" />
      </div>
      <div class="footer_category">
        <div class="company">
          <ul>
            <li class="item"><a @click="route('DcCategory')">商品を選ぶ</a></li>
            <li class="item"><a @click="route('DcPaymentGuide')">ご利用ガイド</a></li>
            <li class="item"><a @click="route('DcRouteConfirm')">搬入経路のご確認</a></li>
            <li class="item"><a @click="route('DcGuideOrder')">送料・納期・配送</a></li>
            <li class="item"><a @click="route('DcGuidePayment')">お支払い方法</a></li>
            <li class="item"><a @click="route('DcCorpInformation')">会社概要</a></li>
            <li class="item"><a @click="route('SupportInput')">お問い合わせ</a></li>
            <li class="item"><a @click="route('UseRule')">利用規約</a></li>
            <li class="item"><a @click="route('DcTokutei')">特定商取引法に基づく表示</a></li>
            <li class="item"><a @click="route('DcPrivacyPolicy')">プライバシーポリシー</a></li>
          </ul>
        </div>
        <div class="category">
          <ul>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 1})">吊戸棚</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 2})">食器棚</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 3})">玄関収納</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 5})">棚板</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 6})">カウンター下収納</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 7})">サイドボード</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 8})">テレビボード</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 9})">本棚</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 14})">クローゼット収納</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 15})">隙間収納</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 18})">シェルフ</a></li>
            <!-- <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 8})">テレビボード</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 2})">食器棚</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 9})">本棚</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 3})">玄関収納</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 14})">クローゼット収納</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 4})">カウンター</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 15})">隙間収納</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 5})">棚板</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 17})">洗面台</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 6})">カウンター下収納</a></li>
            <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 16})">可動間仕切収納</a></li> -->
            <!-- <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 7})">サイドボード</a></li> -->
            <!-- <li class="item_category"><a @click="routeCategory('DcCategory', {cid: 18})">シェルフ</a></li> -->
          </ul>
        </div>
      </div>
    </div>
    <div id="copyright">Copyright ©{{year}} domans all rights reserved. </div>
  </section>
</template>
<script>
import * as App from '../../../utils/App'
import {DC_STORAGE_KEY} from '../../../constants/App'

export default {
  name: 'DcFooter',
  components: {
  },
  props: {
  },
  data () {
    return {
      year: undefined
    }
  },
  computed: {
  },
  methods: {
    route: function (name, params) {
      this.$router.push({
        name: name,
        params: params
      })
    },
    routeCategory: function (name, params) {
      App.removeLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)
      this.$router.push({
        name: name,
        query: params
      })
    },
    getImage: function (image) {
      return App.getYasumokuResource(image)
    }
  },
  mounted: function () {
  },
  created: function () {
    let date = new Date()
    this.year = date.getFullYear()
  }
}
</script>
<style src="../../css/dcfooter.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/common/DcFooter.vue